import { Target } from '../SessionModel';

/**
 * Integer display string for API drill targetQuality (parity with CombineSummaryChart radar labels).
 */
export function formatDrillApiTargetQuality(
  targetQuality: number | string | null | undefined
): string | null {
  if (targetQuality === null || targetQuality === undefined || targetQuality === '') {
    return null;
  }
  const n = typeof targetQuality === 'number' ? targetQuality : Number(targetQuality);
  if (!Number.isFinite(n)) {
    return null;
  }
  return n.toFixed(0);
}

/**
 * Key Data quality tile: prefer API targetQuality (matches radar); else client average from shots.
 */
export function getCombineKeyDataQuality(target: Target): {
  display: string;
  rangeValue: number;
} {
  const raw = target.drillTarget?.targetQuality;
  const fromApi = formatDrillApiTargetQuality(raw);
  if (fromApi !== null) {
    const n = typeof raw === 'number' ? raw : Number(raw);
    return { display: fromApi, rangeValue: Number.isFinite(n) ? n : 0 };
  }

  const fallback = target.average.quality?.value;
  if (fallback === undefined || fallback === null || fallback === '---') {
    return { display: '---', rangeValue: 0 };
  }
  const parsed = parseFloat(String(fallback));
  return {
    display: String(fallback),
    rangeValue: Number.isFinite(parsed) ? parsed : 0,
  };
}
